// Importar primeiro para garantir que o localStorage seja substituído
import './utils/storageUtils';
// Import Sentry configuration
import './lib/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
// OTIMIZAÇÃO: Descomente a linha abaixo para usar a versão otimizada
// import App from './AppOptimized';
import App from './App';
import './index.css';
import { requestChunkReload } from './lib/chunkReload';

// Depois de um novo deploy, abas já abertas ainda referenciam chunks com hash antigo
// que não existem mais no servidor. Isso derruba qualquer import() dinâmico (rotas
// lazy como o Kanban) com "Failed to fetch dynamically imported module". O Vite emite
// vite:preloadError nesse caso; recarregamos a página uma vez para pegar o index.html
// novo (com os hashes certos).
//
// O preventDefault() é essencial: sem ele o helper do Vite re-lança o erro
// (`if (!e.defaultPrevented) throw err`), que sobe pelo React.lazy até o
// ErrorBoundary e vira um issue no Sentry a cada deploy, mesmo o reload
// resolvendo sozinho logo em seguida.
//
// Se o guard barrar o reload (o erro persiste — deploy realmente quebrado),
// deixamos o erro seguir para o ErrorBoundary mostrar a tela de falha.
window.addEventListener('vite:preloadError', (event) => {
  if (requestChunkReload()) {
    event.preventDefault();
  }
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
